<template>
  <div>
    <link
      href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet"
    />
    <transition name="fade">
      <div class="loading" v-if="this.$store.getters.isLoading">
        <Spinner
          class="loading-image"
          :line-size="7"
          size="55"
          line-fg-color="#548CA8"
        />
      </div>
    </transition>
    <Message />
    <Header />

    <!-- <b-form-row class="w-100"> -->

      <!-- <b-col class="px-0 h-full-max" :cols="isLogged ? 10 : 12"> -->
        <router-view />
      <!-- </b-col> -->
    <!-- </b-form-row> -->
    <Popup-container />
    <Dialog ref="confirmDialog" />
  </div>
</template>

<script>
import Vue from "vue";
import Spinner from "vue-simple-spinner";
import Header from "./view/header/Header";
// import SideBar from "./view/header/SideBar";
import Message from "./components/Message";
import PopupContainer from "./components/PopupContainer";
import Dialog from "./components/Dialog";

import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    Header,
    Spinner,
    Message,
    PopupContainer,
    Dialog,
    // SideBar
  },
  computed: {
    ...mapGetters({
      isLogged: "isLogged"
    })
  },
  mounted() {
    Vue.prototype.$confirmDialog = this.$refs.confirmDialog;
  }
};
</script>

<style>
html,
body {
  height: 94vh;
  width: 100%;
  font-family: "Lato", sans-serif;
}

.breadcrumb {
  background-color: #eeeeee !important;
}

.bg-dark {
  background-color: #334257 !important;
}

.alinhamento-central {
  justify-content: center;
  align-items: center;
}

.width-20 {
  width: 20px;
}

.width-50 {
  width: 50px;
}

.width-70 {
  width: 70px;
}

.width-100 {
  width: 100px;
}

.width-130 {
  width: 130px;
}

.width-150 {
  width: 150px;
}

.width-200 {
  width: 200px;
}

.width-230 {
  width: 230px;
}

.width-300 {
  width: 300px;
}

a:hover {
  text-decoration: none;
}

.w-40 {
  width: 40%;
}

.c-white {
  color: #ffff;
}

.a-white {
  color: #ffff;
  text-decoration: none
}

.a-white:hover {
  color: rgb(160, 160, 160);
}

.c-pointer {
  cursor: pointer;
}

.loading {
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: black;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100000;
  opacity: 0.5;
  cursor: wait;
}

.loading-image {
  position: fixed;
  top: 50%;
  left: 50%;
  margin: -50px 0px 0px -50px;
}

/* .active {
  font-weight: 700;
  cursor: default;
} */

.h18 {
  height: 18px;
}

.li-off {
  color: #231f20 !important;
  font-weight: 500;
}

.button-base {
  background-color: #f39c12;
  color: #fff;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  height: 33px;
  font-weight: 500;
}

.button-base:hover {
  background-color: #ca871c;
}

.button-base:focus {
  box-shadow: 0 0 0 0;
  border: 0 none;
  outline: 0;
}

.title-label {
  color: #4c4c4c;
  font-weight: 500;
  font-size: 15px;
}

.button-send {
  color: #fff;
  background-color: #f39c12;
  font-weight: 500;
}

.button-send:hover {
  background-color: #ffa20d;
}

.color-white {
  color: #fff !important;
}

.h-full {
  height: 93vh;
  overflow-y: auto;
}

.h-full-max {
  max-height: 93vh;
  overflow-x: auto;
}

@media screen and (max-height: 720px) {
  .h-full {
    height: 88vh;
  }
  .h-full-max {
    max-height: 88vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue